import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 120000,
});

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("iryaa_admin_token");
  if (token && config.url && config.url.startsWith("/admin")) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// If any /admin/* call returns 401, the token is stale/expired — clear it
// so the Admin UI re-mounts to the login screen instead of showing an empty dashboard.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && url.startsWith("/admin")) {
      const had = localStorage.getItem("iryaa_admin_token");
      if (had) {
        localStorage.removeItem("iryaa_admin_token");
        // Notify the Admin page (and any listener) to swap to the login screen.
        window.dispatchEvent(new Event("iryaa:admin-unauthorized"));
      }
    }
    return Promise.reject(err);
  }
);

export const WHATSAPP_NUMBER = "918971188977";
export const whatsappLink = (msg = "Hello Iryaa Homes, I would like to enquire about a piece.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
